export default "__VITE_ASSET__DA5F8Ph___"